import { Link, useNavigate } from "react-router-dom";
import { Leaf } from "lucide-react";
import { useState } from "react";
import { useLang } from "@/context/LangContext";
import { useAuth } from "@/context/AuthContext";
import { useSettings } from "@/context/SettingsContext";
import { mediaUrl } from "@/lib/api";
import { LanguageSwitcher, ThemeToggle } from "@/components/HeaderControls";
import { DesktopNav, MobileNav } from "@/components/HeaderNav";

const useLinks = () => {
  const { t } = useLang();
  const { user } = useAuth();
  const links = [
    { to: "/", label: t("nav_home"), id: "home" },
    { to: "/#packages", label: t("nav_packages"), id: "packages" },
    { to: "/#about", label: t("nav_about"), id: "about" },
  ];
  if (user?.role === "admin") links.push({ to: "/admin", label: t("nav_admin"), id: "admin" });
  else if (user) links.push({ to: "/dashboard", label: t("nav_dashboard"), id: "dashboard" });
  else links.push({ to: "/login", label: t("nav_login"), id: "login" });
  return links;
};

const Brand = () => {
  const { settings } = useSettings();
  return (
    <Link to="/" data-testid="header-logo" className="flex min-w-0 items-center gap-3">
      <span className="flex h-10 w-10 shrink-0 items-center justify-center overflow-hidden rounded-xl bg-primary text-primary-foreground">
        {settings?.logo_url ? <img src={mediaUrl(settings.logo_url)} alt="logo" className="h-full w-full object-cover" /> : <Leaf className="h-5 w-5" />}
      </span>
      <span className="truncate text-lg font-extrabold tracking-tight sm:text-xl" data-testid="header-org-name">
        {settings?.org_name || "ወንድማቾች ለጋራ"}
      </span>
    </Link>
  );
};

export const Header = () => {
  const { user, logout } = useAuth();
  const links = useLinks();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const doLogout = async () => { await logout(); setOpen(false); navigate("/"); };

  return (
    <header className="fixed inset-x-0 top-0 z-50 border-b border-border bg-background/80 backdrop-blur-md">
      <div className="mx-auto flex h-20 max-w-7xl items-center justify-between gap-4 px-4 sm:px-6 lg:px-12">
        <Brand />
        <div className="flex items-center gap-2">
          <DesktopNav links={links} user={user} onLogout={doLogout} />
          <LanguageSwitcher />
          <ThemeToggle />
          <MobileNav links={links} user={user} onLogout={doLogout} open={open} setOpen={setOpen} />
        </div>
      </div>
    </header>
  );
};
